import React from 'react';

interface WorkerOnlineStatusProps {
  isOnline: boolean;
  workerName: string;
  size?: 'sm' | 'md' | 'lg';
  showName?: boolean;
}

const WorkerOnlineStatus: React.FC<WorkerOnlineStatusProps> = ({ 
  isOnline, 
  workerName, 
  size = 'sm', 
  showName = true 
}) => {
  // 크기별 스타일
  const sizeStyles = {
    sm: {
      dot: 'w-2 h-2',
      text: 'text-xs'
    },
    md: {
      dot: 'w-3 h-3',
      text: 'text-sm'
    },
    lg: {
      dot: 'w-4 h-4',
      text: 'text-base'
    }
  };
  
  const styles = sizeStyles[size];
  
  return (
    <div className="flex items-center gap-1">
      {/* 접속 상태 점 */}
      <div className="relative">
        <div 
          className={`${styles.dot} rounded-full ${
            isOnline ? 'bg-green-500' : 'bg-gray-400'
          }`}
        />
        {/* 온라인일 때 펄스 효과 */}
        {isOnline && (
          <div 
            className={`${styles.dot} rounded-full bg-green-500 absolute top-0 left-0 animate-ping opacity-30`}
          />
        )}
      </div>
      
      {/* 작업자 이름 */}
      {showName && (
        <span className={`${styles.text} text-gray-700 truncate`}>
          {workerName}
        </span>
      )}
    </div>
  );
};

export default WorkerOnlineStatus;
